import { Pipe, PipeTransform } from '@angular/core';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { UnderlyingAssetsFE } from 'src/app/product-capture/model/interfaces/underlying-assets-fe.interface';

@Pipe({
  name: 'filterFxAssets',
})
export class FilterFxAssetsPipe implements PipeTransform {
  transform(
    underlyingAssetItems: UnderlyingAssetsFE[],
    productType?: ProductTypeEnum,
    currency?: string
  ): UnderlyingAssetsFE[] {
    const filterExpression = (item: UnderlyingAssetsFE) =>
      productType === ProductTypeEnum.CHOOSER && currency
        ? item.type === 'FX' && item.currency === currency
        : item.type === 'FX';

    return underlyingAssetItems.filter(filterExpression);
  }
}
